import React from 'react'
import {
  withStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'
import { styled } from '@material-ui/core'
import styles from '../styles'
import {
  AuthenticatedLinksViewContent,
  UpgradePopover,
  AccordionSummaryContent,
} from '..'
import { useSelector } from 'react-redux'

import UserType from 'src/model/user-types'
import { hasInAppAuthAccess } from '../../utils/in-app-auth-access'

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  width: '100%',
  '&.Mui-expanded': {
    boxShadow: 'none',
  },
}))

const AuthenticatedLinks = props => {
  const { accessRule, handleAccessRule, classes } = props
  const entity = useSelector(state => state.collection.collection)

  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]
  const accessSpecificUsersControl = () => {
    return !hasInAppAuthAccess(userControl)
  }
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const handleClickSwitch = event => {
    accessSpecificUsersControl() ? handleClick(event) : handleAccessRule(3)
  }
  return (
    <div className={classes.root}>
      <StyledAccordion expanded={accessRule == 3}>
        <AccordionSummary
          className={classes.accordion__summary}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <AccordionSummaryContent
            accessRule={accessRule}
            handleClickSwitch={handleClickSwitch}
            contentHeader={'In-app authentication'}
            contentDescription={
              'Grant access to logged in users in your product'
            }
            id={id}
            badgeType={7}
            open={open}
            anchorEl={anchorEl}
            handleClose={handleClose}
            popupHeader={'Get quote'}
            popupContent={
              'In-app authentication is available on the Headless plans. Upgrade to unlock this feature.'
            }
            accessRuleEqual={3}
          />
        </AccordionSummary>

        <AccordionDetails className={classes.accordion__details}>
          <AuthenticatedLinksViewContent entity={entity} />
        </AccordionDetails>
      </StyledAccordion>
      <UpgradePopover
        id={id}
        anchorEl={anchorEl}
        handleClose={handleClose}
        open={open}
        header={'Get quote'}
        content={
          'Unlock in-app authentication to grant access to logged in users in your product.'
        }
        accessRuleEqual={3}
      />
    </div>
  )
}

export default withStyles(styles)(AuthenticatedLinks)
